import * as yup from 'yup';
import { Formik } from 'formik';
import { Box } from '@mui/material';
import { SecretField } from '@qrios/frontend-library';

import locales from '../../../../../../../../../constants/locales';
import Typography from '../../../../../../../../common/typography';
import WithFormLayout from '../../../../../../../../common/with-form-layout';
import { BusinessError } from '../../../../../../../../common/business-error';
import { OTP_VERIFICATION } from '../../../../../../../../../constants/formInputs';
import { otpSmsValidation } from '../../../../../../../../../constants/validation';

import { OtpValue } from '../interfaces';

const validationSchema = yup.object().shape({
  [OTP_VERIFICATION.SMS]: otpSmsValidation
});

interface Props {
  ussdShortcodeToDial?: string;
  userMsisdn?: string;
  handleClose: () => void;
  loading: boolean;
  onSubmit: (otp: OtpValue) => void;
  error?: BusinessError | null;
}

const OtpVerificationPhoneAndUssdForm = ({
  handleClose,
  loading,
  onSubmit,
  error = null,
  userMsisdn,
  ussdShortcodeToDial
}: Props) => (
  <Formik
    initialValues={{
      [OTP_VERIFICATION.SMS]: ''
    }}
    validationSchema={validationSchema}
    onSubmit={values => {
      onSubmit(values);
    }}
  >
    {({ values, handleChange, handleSubmit, errors, touched, handleBlur }) => (
      <>
        <WithFormLayout
          submitLabel="Verify OTP"
          secondaryLabel="Close without update"
          onSubmit={handleSubmit}
          onSecondary={handleClose}
          loading={loading}
          error={error}
        >
          <Box sx={{ display: 'flex', marginBottom: '8px' }}>
            <Typography color="#4A4A4A" size={14}>
              Enter the OTP you recived to &nbsp;
            </Typography>
            {userMsisdn ? (
              <Typography size={14}>{userMsisdn}.</Typography>
            ) : (
              <Typography color="#4A4A4A" size={14}>
                your phone.
              </Typography>
            )}
          </Box>
          <Box mb={1}>
            <SecretField
              name={OTP_VERIFICATION.SMS}
              value={values[OTP_VERIFICATION.SMS]}
              handleChange={handleChange}
              handleBlur={handleBlur}
              label=""
              error={errors[OTP_VERIFICATION.SMS]}
              touched={touched[OTP_VERIFICATION.SMS]}
              placeholder={locales.otp.label.sms}
            />
          </Box>
          {ussdShortcodeToDial && (
            <Box sx={{ display: 'flex', marginBottom: '16px' }}>
              <Typography size={14} color="#4A4A4A">
                If you didn&#39;t receive the previous OTP on your phone, you can also call the
              </Typography>
              <Typography size={14} color="#00683E">
                {ussdShortcodeToDial}
              </Typography>
            </Box>
          )}
        </WithFormLayout>
      </>
    )}
  </Formik>
);

export default OtpVerificationPhoneAndUssdForm;
